/* ALEXALAB · Página de producto "Vitrina nocturna" */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;

  /* ---------- Aparición al desplazarse ---------- */
  var io = null;
  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-rv]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
            if (e.target.hasAttribute('data-count')) count(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    }
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-count')) count(el);
      } else {
        io.observe(el);
      }
    });
    html.classList.add('alx-rv-ready');
  }

  /* ---------- Cifras que cuentan ---------- */
  function count(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var out = el.querySelector('[data-count-out]');
    if (!out || isNaN(target)) return;
    if (reduce) { out.textContent = target; return; }
    var start = null;
    var dur = 1600;
    function step(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      out.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    out.textContent = '0';
    requestAnimationFrame(step);
  }

  /* ---------- Pestañas (portada y explorador) ---------- */
  function tabs(root) {
    root.querySelectorAll('[data-tabs]').forEach(function (group) {
      if (group.__alxTabs) return;
      group.__alxTabs = true;
      var btns = group.querySelectorAll('[data-tab]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab');
          btns.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); b.tabIndex = b === btn ? 0 : -1; });
          group.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
        });
        btn.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var list = Array.prototype.slice.call(btns);
          var i = list.indexOf(btn) + (e.key === 'ArrowRight' ? 1 : -1);
          var next = list[(i + list.length) % list.length];
          next.focus(); next.click();
        });
      });
    });
  }

  /* ---------- Galería de la portada ---------- */
  function gallery(root) {
    root.querySelectorAll('[data-pd-gallery]').forEach(function (g) {
      if (g.__alxGal) return;
      g.__alxGal = true;
      var track = g.querySelector('.pd-vis__track');
      var dots = g.querySelectorAll('.pd-dot');
      var cnt = g.querySelector('.pd-count [data-now]');
      if (!track) return;
      function set(i) {
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (cnt) cnt.textContent = String(i + 1).padStart(2, '0');
      }
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * k, behavior: reduce ? 'auto' : 'smooth' }); });
      });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { set(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
      }, { passive: true });
    });
  }

  /* ---------- Variantes: precio y botón ---------- */
  function variants(root) {
    root.querySelectorAll('[data-pd-variants]').forEach(function (sel) {
      if (sel.__alxVar) return;
      sel.__alxVar = true;
      var data;
      try { data = JSON.parse(document.getElementById(sel.getAttribute('data-pd-variants')).textContent); } catch (e) { return; }
      var card = sel.closest('.pd-card');
      sel.addEventListener('change', function () {
        var v = data.find(function (x) { return String(x.id) === sel.value; });
        if (!v || !card) return;
        var now = card.querySelector('[data-price-now]');
        var was = card.querySelector('[data-price-was]');
        var save = card.querySelector('[data-price-save]');
        var buy = card.querySelector('.pd-buy');
        if (now) now.textContent = v.price;
        if (was) { was.textContent = v.compare || ''; was.hidden = !v.compare; }
        if (save) { save.textContent = v.save || ''; save.hidden = !v.save; }
        if (buy) buy.disabled = !v.available;
        document.querySelectorAll('[data-bar-price]').forEach(function (b) { b.textContent = v.price; });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------- Barra de compra fija ---------- */
  function bar() {
    var b = document.querySelector('[data-pd-bar]');
    var card = document.querySelector('.pd-card');
    if (!b || !card || b.__alxBar) return;
    b.__alxBar = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          b.classList.toggle('is-visible', past);
        });
      }, { threshold: 0 }).observe(card);
    }
    b.querySelector('.pd-bar__btn').addEventListener('click', function () {
      var mode = b.getAttribute('data-mode');
      var submit = card.querySelector('.pd-buy');
      if (mode === 'click' && submit && submit.offsetParent !== null) { submit.click(); return; }
      card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      card.classList.add('is-flash');
      setTimeout(function () { card.classList.remove('is-flash'); }, 1400);
    });
  }

  /* ---------- Recorrido fijo (efecto de página que avanza sin avanzar) ---------- */
  var pins = [];
  function pinned(root) {
    root.querySelectorAll('[data-pd-pin]').forEach(function (sec) {
      if (sec.__alxPin) return;
      sec.__alxPin = true;
      var slides = sec.querySelectorAll('.pd-pin__slide');
      if (slides.length < 2 || reduce) return;
      var track = sec.querySelector('.pd-pin__track');
      var per = parseFloat(sec.getAttribute('data-step') || '70');
      sec.classList.add('is-pinned');
      track.style.height = (slides.length * per + 100) + 'vh';
      pins.push({
        sec: sec, track: track, slides: slides,
        spots: sec.querySelectorAll('.pd-spot'),
        frame: sec.querySelector('.pd-pin__frame'),
        now: sec.querySelector('[data-pin-now]'),
        last: -1
      });
    });
    onScroll();
  }
  function updatePin(p) {
    var r = p.track.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var prog = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
    var n = p.slides.length;
    var i = Math.min(n - 1, Math.floor(prog * n));
    p.sec.style.setProperty('--pin-p', prog.toFixed(4));
    if (p.frame) p.frame.style.transform = 'scale(' + (1 + prog * 0.06).toFixed(4) + ') rotate(' + ((prog - 0.5) * 6).toFixed(2) + 'deg)';
    if (i === p.last) return;
    p.last = i;
    p.slides.forEach(function (s, k) {
      s.classList.toggle('is-active', k === i);
      s.classList.toggle('is-past', k < i);
      s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
    p.spots.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    if (p.now) p.now.textContent = String(i + 1).padStart(2, '0');
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      pins.forEach(function (p) { if (document.body.contains(p.sec)) updatePin(p); });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Arranque ---------- */
  function init(root) {
    root = root || document;
    reveal(root);
    tabs(root);
    gallery(root);
    variants(root);
    pinned(root);
    bar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------- v5 · Puntos de las pestañas con etapas ---------- */
(function () {
  function points(root) {
    (root || document).querySelectorAll('[data-points]').forEach(function (panel) {
      if (panel.__alxPts) return;
      panel.__alxPts = true;
      var out = panel.querySelector('[data-points-out]');
      var btns = panel.querySelectorAll('.pd-st__pt');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
          if (out) {
            out.textContent = b.getAttribute('data-desc') || '';
            out.style.animation = 'none';
            void out.offsetWidth;
            out.style.animation = '';
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { points(); });
  else points();
  document.addEventListener('shopify:section:load', function (e) { points(e.target); });
})();

/* ==========================================================
   ALEXALAB · V6 · Navegación de capítulos + laboratorio
   ========================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerHeight() {
    var header = document.querySelector('.section-header, shopify-section-header-sticky, #shopify-section-header');
    var h = header && header.offsetHeight ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--pd-v6-header-h', h + 'px');
  }

  function scrollToTarget(selector) {
    var el = document.querySelector(selector);
    if (!el) return;
    var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pd-v6-header-h')) || 0;
    var nav = document.querySelector('[data-pd-v6nav]');
    var n = nav ? nav.offsetHeight : 0;
    var top = el.getBoundingClientRect().top + window.scrollY - h - n - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  function v6Nav(root) {
    var nav = (root || document).querySelector('[data-pd-v6nav]') || document.querySelector('[data-pd-v6nav]');
    if (!nav || nav.__alxV6Nav) return;
    nav.__alxV6Nav = true;
    headerHeight();

    var buttons = Array.prototype.slice.call(nav.querySelectorAll('[data-alx-nav-target]'));
    buttons.forEach(function (btn) {
      var selector = btn.getAttribute('data-alx-nav-target');
      btn.hidden = !selector || !document.querySelector(selector);
    });

    document.querySelectorAll('[data-alx-jump]').forEach(function (btn) {
      if (btn.__alxJump) return;
      btn.__alxJump = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var selector = btn.getAttribute('data-alx-jump');
        if (selector) scrollToTarget(selector);
      });
    });

    var visibleButtons = buttons.filter(function (b) { return !b.hidden; });
    var targets = visibleButtons.map(function (b) { return document.querySelector(b.getAttribute('data-alx-nav-target')); });

    function update() {
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pd-v6-header-h')) || 0;
      var anchor = h + nav.offsetHeight + Math.min(window.innerHeight * .2, 180);
      var active = -1;
      targets.forEach(function (el, i) {
        if (el && el.getBoundingClientRect().top <= anchor) active = i;
      });
      if (active < 0 && visibleButtons.length) active = 0;
      visibleButtons.forEach(function (b, i) { b.classList.toggle('is-active', i === active); });
      if (active >= 0 && visibleButtons[active] && visibleButtons[active].scrollIntoView) {
        var scroller = nav.querySelector('.pd-v6nav__scroller');
        var b = visibleButtons[active];
        if (scroller && (b.offsetLeft < scroller.scrollLeft || b.offsetLeft + b.offsetWidth > scroller.scrollLeft + scroller.clientWidth)) {
          scroller.scrollTo({ left: Math.max(0, b.offsetLeft - scroller.clientWidth / 2 + b.offsetWidth / 2), behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      var startEl = document.querySelector('.pd-hero');
      var endEls = document.querySelectorAll('body.alx-t-product main .pd');
      var endEl = endEls.length ? endEls[endEls.length - 1] : null;
      if (startEl && endEl) {
        var start = startEl.offsetTop;
        var end = endEl.offsetTop + endEl.offsetHeight - window.innerHeight;
        var p = end > start ? (window.scrollY - start) / (end - start) : 0;
        p = Math.max(0, Math.min(1, p));
        nav.style.setProperty('--pd-v6-progress', p.toFixed(4));
      }
    }

    var ticking = false;
    function tick() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { headerHeight(); tick(); });
    update();
  }

  function v6Tilt(root) {
    if (reduce || !window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;
    (root || document).querySelectorAll('[data-v6-tilt]').forEach(function (el) {
      if (el.__alxTilt) return;
      el.__alxTilt = true;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5;
        var y = (e.clientY - r.top) / r.height - .5;
        el.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
      });
    });
  }

  function v6Accordion(root) {
    (root || document).querySelectorAll('[data-v6-accordion]').forEach(function (group) {
      if (group.__alxAcc) return;
      group.__alxAcc = true;
      group.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== d) other.removeAttribute('open');
          });
        });
      });
    });
  }

  function initV6(root) {
    headerHeight();
    v6Nav(root || document);
    v6Tilt(root || document);
    v6Accordion(root || document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initV6(document); });
  else initV6(document);
  document.addEventListener('shopify:section:load', function (e) { initV6(e.target); });
})();
